import React from "react";

export type DogLoveProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 40,
    height: 40,
  },
  medium: {
    width: 40,
    height: 40,
  },
  large: {
    width: 40,
    height: 40,
  },
};

export const DogLove = React.forwardRef<SVGSVGElement, DogLoveProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "black" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 36.4516C20 36.4516 37.4375 26.0322 37.4375 12.5967C37.4382 10.5843 36.7509 8.62915 35.4841 7.04032C34.2173 5.45149 32.4433 4.3197 30.4428 3.82393C28.4422 3.32816 26.3292 3.49671 24.438 4.30292C22.5467 5.10912 20.985 6.50697 20 8.27543C19.015 6.50697 17.4533 5.10912 15.562 4.30292C13.6708 3.49671 11.5578 3.32816 9.55723 3.82393C7.55668 4.3197 5.78275 5.45149 4.51594 7.04032C3.24913 8.62915 2.56175 10.5843 2.5625 12.5967C2.5625 26.0322 20 36.4516 20 36.4516Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.875 35.3549V34.2581C20 33.1613 20.5625 32.6129 20.5625 30.4194V28.2258"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33984 26.0322C10.092 23.7962 11.2042 21.1469 11.563 18.3548C12.1255 14.5161 15.1067 11.7742 18.8755 11.7742C20.1819 11.8131 21.4843 11.9377 22.7736 12.1471C23.1063 12.1946 23.4169 12.338 23.6654 12.5588C23.914 12.7797 24.0892 13.0679 24.1686 13.3864C24.3099 14.1797 24.6141 14.937 25.063 15.6129C25.7998 16.408 28.798 17.0442 30.0917 17.2909C30.1678 17.3055 30.24 17.3353 30.3037 17.3784C30.3674 17.4215 30.4213 17.477 30.462 17.5414C30.5026 17.6058 30.5292 17.6776 30.54 17.7525C30.5509 17.8274 30.5457 17.9036 30.5248 17.9764L29.5742 21.2667C29.4126 21.8473 29.0596 22.3599 28.5696 22.7255C28.0797 23.0912 27.48 23.2897 26.863 23.2903H22.2505"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9375 18.3548C14.9375 18.3548 14.9769 22.1222 14.9769 24.6832C14.9575 25.1656 15.0383 25.6468 15.2143 26.0981C15.3903 26.5494 15.6579 26.9613 16.0012 27.3093C16.3444 27.6573 16.7562 27.9342 17.2119 28.1233C17.6675 28.3124 18.1576 28.4098 18.6528 28.4098C19.148 28.4098 19.6381 28.3124 20.0938 28.1233C20.5494 27.9342 20.9612 27.6573 21.3044 27.3093C21.6477 26.9613 21.9153 26.5494 22.0914 26.0981C22.2674 25.6468 22.3481 25.1656 22.3287 24.6832C22.3287 22.1222 18.6556 20.5593 18.6556 16.079"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.125 16.7097C21.125 16.4188 21.2435 16.1398 21.4545 15.9342C21.6655 15.7285 21.9516 15.6129 22.25 15.6129C22.5484 15.6129 22.8345 15.7285 23.0455 15.9342C23.2565 16.1398 23.375 16.4188 23.375 16.7097"
          fill={color}
        />
        <path
          d="M27.875 17.2581V17.8064C27.875 18.2428 28.0528 18.6612 28.3693 18.9697C28.6857 19.2783 29.1149 19.4516 29.5625 19.4516V19.4516"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

DogLove.displayName = "DogLove";
